/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Peer_Support_Landing_TaglineInputs */

const en_service_peer_support_landing_tagline = /** @type {(inputs: Service_Peer_Support_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymous Online Peer Community`)
};

const fr_service_peer_support_landing_tagline = /** @type {(inputs: Service_Peer_Support_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté anonyme de soutien en ligne`)
};

/**
* | output |
* | --- |
* | "Anonymous Online Peer Community" |
*
* @param {Service_Peer_Support_Landing_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_peer_support_landing_tagline = /** @type {((inputs?: Service_Peer_Support_Landing_TaglineInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Peer_Support_Landing_TaglineInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_peer_support_landing_tagline(inputs)
	return fr_service_peer_support_landing_tagline(inputs)
});